interface QuoteIconProps extends React.HTMLAttributes<SVGElement> {
  color: string;
}

export const QuoteCloseIcon = (props: QuoteIconProps) => {
  const { color, className, ...rest } = props;

  return (
    <svg
      width='83'
      height='76'
      viewBox='0 0 83 76'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...rest}
    >
      <path
        d='M0.803125 75.5999L14.0031 20.3999L16.4031 32.9999C11.8031 32.9999 7.90312 31.5999 4.70312 28.7999C1.70312 25.7999 0.203125 21.8999 0.203125 17.0999C0.203125 12.2999 1.70312 8.3999 4.70312 5.39989C7.90312 2.39989 11.7031 0.899902 16.1031 0.899902C20.7031 0.899902 24.4031 2.4999 27.2031 5.69991C30.2031 8.6999 31.7031 12.4999 31.7031 17.0999C31.7031 18.6999 31.6031 20.2999 31.4031 21.8999C31.2031 23.4999 30.8031 25.2999 30.2031 27.2999C29.8031 29.0999 29.1031 31.3999 28.1031 34.1999L15.2031 75.5999H0.803125ZM51.8031 75.5999L65.0031 20.3999L67.4031 32.9999C62.8031 32.9999 58.9031 31.5999 55.7031 28.7999C52.7031 25.7999 51.2031 21.8999 51.2031 17.0999C51.2031 12.2999 52.7031 8.3999 55.7031 5.39989C58.9031 2.39989 62.7031 0.899902 67.1031 0.899902C71.7031 0.899902 75.4031 2.4999 78.2031 5.69991C81.2031 8.6999 82.7031 12.4999 82.7031 17.0999C82.7031 18.6999 82.6031 20.2999 82.4031 21.8999C82.2031 23.4999 81.8031 25.2999 81.2031 27.2999C80.8031 29.0999 80.1031 31.3999 79.1031 34.1999L66.2031 75.5999H51.8031Z'
        fill={color}
      />
    </svg>
  );
};
